import { ActionButton } from '../ActionButton/ActionButton';

/**
 * {@docCategory CompatButton}
 */
export const CommandButton = ActionButton;
